import React from 'react';
import { connect } from 'react-redux';
import { Badge } from 'reactstrap';
import { faCheck, faExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const getConfig = (status) => {
  switch (status) {
    case 'valid':
      return { color: 'success', icon: faCheck, text: 'Your file is ready for upload.' };
    case 'processed':
      return { color: 'success', icon: faCheck, text: 'Changes saved to database.' };
    default:
      return {
        color: 'warning',
        icon: faExclamation,
        text: 'Errors found. Please edit your file and try again.',
      };
  }
};

const SummaryLabel = ({ status }) => {
  const config = getConfig(status);

  return (
    <h5 className="d-flex justify-content-center mb-2">
      <Badge
        color={config.color}
        className="text-capitalize me-2 d-flex align-items-center"
      >
        <FontAwesomeIcon icon={config.icon} className="me-1" />
        {status}
      </Badge>
      {config.text}
    </h5>
  );
};

const mapStateToProps = (store) => ({
  status: store.batch.apiStatus,
});

export default connect(mapStateToProps)(SummaryLabel);
